import {
    createVNode as _$cv,
    className as _$cn,
    createUnknownComponentVNode as _$cc,
    createElementVNode as _$ce,
} from 'intact';
import {Button} from '../button';
import {getRestProps} from '../utils';
import {makeStyles} from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {className, children, vertical, size, type} = this.get();
    const {
        isScroll, left, enablePrev, enableNext,
        prev, next, scrollRef, wrapperRef
    } = this.scroll;
    const classNameObj = {
        'k-tabs': true,
        [`k-${size}`]: size,
        'k-vertical': vertical,
        'k-tabs-card': type === 'no-border-card',
        [`k-tabs-${type}`]: type !== 'default',
        [`k-is-scroll`]: isScroll.value,
        [className]: className,
        [makeStyles()]: true,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, [
        (isScroll.value) ?
            _$cc(Button, {
                'className': 'k-tabs-prev',
                'type': 'none',
                'icon': true,
                'key': 'prev',
                'size': size,
                'disabled': !enablePrev.value,
                'ev-click': prev,
                'children': (
                    _$ce(2, 'i', null, 1, 'ion-ios-arrow-left')
                )
            }, 'prev') :
            undefined,
        _$ce(2, 'div', (
            _$ce(2, 'div', [
                children,
                _$ce(2, 'div', null, 1, 'k-tabs-active-bar', {
                    'style': this.activeBar.value
                })
            ], 0, 'k-tabs-wrapper', {
                'style': {transform: `translateX(${left.value}px)`}
            }, null, wrapperRef)
        ), 2, 'k-tabs-scroll c-clearfix', null, null, scrollRef),
        (isScroll.value) ?
            _$cc(Button, {
                'className': 'k-tabs-next',
                'type': 'none',
                'icon': true,
                'key': 'next',
                'size': size,
                'disabled': !enableNext.value,
                'ev-click': next,
                'children': (
                    _$ce(2, 'i', null, 1, 'ion-ios-arrow-right')
                )
            }, 'next') :
            undefined
    ]);
};